@if (article) {
  <div>
    {{ article.location }}{{ article.location ? ', ' : '' }}{{ article.displayDate | localizedDate: 'longDate' }}
  </div>
  <div class="article-headline">{{ article.title }}</div>
  @if (showMetaItems) {
    <mb-meta-items [metaItems]="article.metaItems" itemClass="btn btn-plain"></mb-meta-items>
  }
}
